var render = function render(_c,_vm){return _c('div',{staticClass:"py-3 whitespace-no-wrap"},[_vm._v(_vm._s(_vm._f("date")(_vm.props.item[_vm.props.value])))])
}
var staticRenderFns = []

export { render, staticRenderFns }